<template>
    <div :class="{'col-sm-12':!service.viewPage,'col-sm-12':service.viewPage,'add-btn-mobile-position subtotal-mobile-position':true}" style="text-align:right;">
        <div class="service-pricing-col">
            <span class="text-style-n">Total  {{ currency.currency_symbol }}<span>{{ subTotal.toFixed(2) }}</span></span>
            <input type="hidden" :name="name"  v-model="subTotal">
        </div>
    </div>
</template>

<script>
export default {
    name: "SubTotalField",
    props: ["subTotal","currency","service"],
    computed:{

        name() {
            if (parseInt(this.service.clone)) {
                return `attributes_${this.service.service_id}_${this.service.clone}_extraCharge`;
            }
            return `attributes_${this.service.service_id}_extraCharge`;
        }
    }
}
</script>

<style scoped>
.text-style-n{
    font-family: Roboto;
    letter-spacing: 0em;
    color: #2E4051;
    text-align: right;
}
</style>